<script>
/*
  Vision Venture — Redeem Card
  - Design: horizontal card ภาพซ้าย + content ขวา (ไม่มีปุ่ม)
  - Layout: [image ~124×124] [title + points row + user-points row]
*/
export default {
  name: "VvRedeemCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    dataTest: {
      type: String,
      required: true
    }
  },
  emits: ["select"],
  computed: {
    profile() {
      return this.$store.state.shortProfile || {};
    },
    image() {
      return this.item.image_url || this.handleImageSrc;
    },
    title() {
      return (
        this.item.product_name ||
        this.item.coupon_language?.[0]?.name ||
        this.item.privilege_language?.[0]?.name ||
        this.item.privilege_name ||
        this.item.name ||
        "-"
      );
    },
    pointUsed() {
      return this.numeralFormat(this.item.point_used || 0);
    },
    userTotalPoint() {
      return this.numeralFormat(this.profile.total_point || 0);
    }
  }
};
</script>

<template>
  <article
    class="vv-redeem-card"
    :data-test="dataTest"
    @click="$emit('select', item)"
  >
    <div class="vv-redeem-card__image-wrap">
      <c-img-lazy :src="image" class="vv-redeem-card__image" />
    </div>

    <div class="vv-redeem-card__body">
      <h3 class="vv-redeem-card__title">{{ title }}</h3>

      <div class="vv-redeem-card__points-row">
        <span class="vv-redeem-card__coin" aria-hidden="true">P</span>
        <span class="vv-redeem-card__points">{{ pointUsed }}</span>
      </div>

      <div class="vv-redeem-card__user-points">
        <span class="vv-redeem-card__user-points-label">
          {{ $t("your_total_point") || "คะแนนสะสมของคุณ" }}
        </span>
        <span class="vv-redeem-card__user-points-value">
          {{ userTotalPoint }}/{{ pointUsed }}
        </span>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.vv-redeem-card {
  display: flex;
  align-items: stretch;
  width: 320px;
  flex: 0 0 320px;
  min-height: 124px;
  overflow: hidden;
  border-radius: 12px;
  background: var(--crm-card-glass-background);
  backdrop-filter: blur(12px);
  cursor: pointer;
  box-shadow: var(--crm-card-glass-box-shadow);
  text-align: left;
}

.vv-redeem-card__image-wrap {
  flex: 0 0 124px;
  width: 124px;
  height: 124px;
  overflow: hidden;
  background: var(--secondary-color-light);
}

.vv-redeem-card__image {
  width: 100%;
  height: 100%;
}

.vv-redeem-card__image :deep(.v-img__img) {
  object-fit: cover;
}

.vv-redeem-card__body {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
}

.vv-redeem-card__title {
  margin: 0;
  color: var(--text-color);
  font-size: var(--font-body-lg);
  font-weight: 600;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.vv-redeem-card__points-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: auto;
}

.vv-redeem-card__coin {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  color: var(--font-primary-color);
  font-size: var(--font-body-sm);
  font-weight: 700;
  line-height: 1;
  flex: 0 0 auto;
}

.vv-redeem-card__points {
  color: var(--primary-color);
  font-size: var(--font-title-sm);
  font-weight: 700;
  line-height: 1.2;
}

.vv-redeem-card__user-points {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--text-color);
  font-size: var(--font-body);
  line-height: 1.4;
}

.vv-redeem-card__user-points-label {
  opacity: 0.7;
}

.vv-redeem-card__user-points-value {
  font-weight: 600;
  white-space: nowrap;
}
</style>
